"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _emotion = require("emotion");

var root = function root(theme) {
  return (
    /*#__PURE__*/
    (0, _emotion.css)("margin-bottom:35px;border-bottom:1px solid #e5ebf5;color:", theme.color.black1, ";")
  );
};

var header =
/*#__PURE__*/
(0, _emotion.css)("display:flex;align-items:center;flex-flow:row nowrap;cursor:pointer;margin-bottom:18px;");
var title =
/*#__PURE__*/
(0, _emotion.css)("flex:1;font-size:13px;text-transform:uppercase;letter-spacing:1px;");
var items =
/*#__PURE__*/
(0, _emotion.css)("margin-bottom:27px;");
var _default = {
  root: root,
  header: header,
  title: title,
  items: items
};
exports.default = _default;